import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";
import AddFarmer from "components/Forms/AddFarmer";
import AddProduct from "components/Forms/AddProduct";
import AddOrder from "components/Forms/AddOrder";
import AddPayment from "components/Forms/AddPayment";
import AddDelivery from "components/Forms/AddDelivery";

// views
import Dashboard from "views/admin/Dashboard.js";
import Farmers from "views/admin/Farmers.js";
import Products from "views/admin/Products.js";
import Orders from "views/admin/Orders.js";
import Payments from "views/admin/Payments.js";
import Deliveries from "views/admin/Deliveries.js";


export default function Admin() {
  const location = useLocation();

  const statsData = {
    "/admin/dashboard": [
      {
        statSubtitle: "TRAFFIC",
        statTitle: "350897",
        statArrow: "up",
        statPercent: "3.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "far fa-chart-bar",
        statIconColor: "bg-red-500",
      },
      {
        statSubtitle: "SALES",
        statTitle: "2086",
        statArrow: "down",
        statPercent: "4.36",
        statPercentColor: "text-red-500",
        statDescripiron: "Since last week",
        statIconName: "fas fa-dollar-sign",
        statIconColor: "bg-orange-500",
      },
      {
        statSubtitle: "PERFORMANCE",
        statTitle: "4965",
        statArrow: "up",
        statPercent: "12",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-award",
        statIconColor: "bg-green 500",
      },
      {
        statSubtitle: "ACTIVE USERS",
        statTitle: "178",
        statArrow: "down",
        statPercent: "0.5",
        statPercentColor: "text-red-500",
        statDescripiron: "Since last week",
        statIconName: "fas fa-user",
        statIconColor: "bg-blue-500",
      },
    ],
    "/admin/farmers": [
      {
        statSubtitle: "FARMERS",
        statTitle: "2500",
        statArrow: "up",
        statPercent: "2.50",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last week",
        statIconName: "fas fa-seedling",
        statIconColor: "bg-green-500",
      },
      {
        statSubtitle: "ACTIVE FARMERS",
        statTitle: "1200",
        statArrow: "up",
        statPercent: "3.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-user-friends",
        statIconColor: "bg-red-500",
      },
      {
        statSubtitle: "INACTIVE FARMERS",
        statTitle: "1300",
        statArrow: "down",
        statPercent: "2.48",
        statPercentColor: "text-red-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-user-slash",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "NEW FARMERS",
        statTitle: "500",
        statArrow: "up",
        statPercent: "5.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-user-plus",
        statIconColor: "bg-green-500",
      }
    ],
    "/admin/products": [
      {
        statSubtitle: "PRODUCTS",
        statTitle: "1234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-box",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "ACTIVE PRODUCTS",
        statTitle: "1000",
        statArrow: "up",
        statPercent: "2.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-box-open",
        statIconColor: "bg-green-500",
      },
      {
        statSubtitle: "INACTIVE PRODUCTS",
        statTitle: "234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-boxes",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "NEW PRODUCTS",
        statTitle: "500",
        statArrow: "up",
        statPercent: "5.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-boxes",
        statIconColor: "bg-green-500",
      }
    ],
    "/admin/orders": [
      {
        statSubtitle: "ORDERS",
        statTitle: "1234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-shopping-cart",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "ACTIVE ORDERS",
        statTitle: "1000",
        statArrow: "up",
        statPercent: "2.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-cart-arrow-down",
        statIconColor: "bg-green-500",
      },
      {
        statSubtitle: "INACTIVE ORDERS",
        statTitle: "234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-cart-plus",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "NEW ORDERS",
        statTitle: "500",
        statArrow: "up",
        statPercent: "5.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-cart-plus",
        statIconColor: "bg-green-500",
      }
    ],
    "/admin/payments": [
      {
        statSubtitle: "REVENUE",
        statTitle: "1234567",
        statArrow: "up",
        statPercent: "1.34",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-wallet",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "EXPENSES",
        statTitle: "234567",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-money-bill-wave",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "OUTSTANDING PAYMENTS",
        statTitle: "234567",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-money-check-alt",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "PAYMENTS",
        statTitle: "234567",
        statArrow: "up",
        statPercent: "1.34",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-money-check-alt",
        statIconColor: "bg-green-500",
      }
    ],
    "/admin/deliveries": [
      {
        statSubtitle: "DELIVERIES",
        statTitle: "1234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-truck",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "COMPLETED DELIVERIES",
        statTitle: "1000",
        statArrow: "up",
        statPercent: "2.48",
        statPercentColor: "text-emerald-500",
        statDescripiron: "Since last month",
        statIconName: "fas fa-truck-loading",
        statIconColor: "bg-green-500",
      },
      {
        statSubtitle: "PENDING DELIVERIES",
        statTitle: "234",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-truck-moving",
        statIconColor: "bg-blue-500",
      },
      {
        statSubtitle: "CANCELLED DELIVERIES",
        statTitle: "34",
        statArrow: "down",
        statPercent: "1.34",
        statPercentColor: "text-red-500",
        statDescripiron: "Since yesterday",
        statIconName: "fas fa-truck",
        statIconColor: "bg-blue-500",
      }
    ]

  };

  // Fallback to empty array if no stats are defined for the route
  const currentStats = statsData[location.pathname] || [];

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* modal here */}

        {/* Header */}
        {/* if the route is /admin/dashboard, the stats will be displayed */}
        {/* {pathParts[pathParts.length - 1] != "create" && */}
        <HeaderStats stats={currentStats} />
        {/* }  */}
        <div className="px-4 md:px-10 mx-auto w-full -m-24 relative">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/farmers" exact component={Farmers} />
            <Route path="/admin/products" exact component={Products} />
            <Route path="/admin/orders" exact component={Orders} />
            <Route path="/admin/payments" exact component={Payments} />
            <Route path="/admin/deliveries" exact component={Deliveries} />
            <Route path="/admin/farmers/create" exact component={AddFarmer} />
            <Route path="/admin/products/create" exact component={AddProduct} />
            <Route path="/admin/orders/create" exact component={AddOrder} />
            <Route path="/admin/payments/create" exact component={AddPayment} />
            <Route path="/admin/deliveries/create" exact component={AddDelivery} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
